import { sectionType } from "../../../../sectionType"

export enum inclusionEnum {
    elevator = 'elevator',
    staircase = 'staircase',
}

export type VariantDefinition<variantEnum> = {
    variant: variantEnum;
    sections: sectionType[];
}

export type FloorDefinition<variantEnum> = {
    floors: number,
    variants: VariantDefinition<variantEnum>[];
}

export type SegmentDefinition<segmentType, variantEnum, subtypeEnum> = {
    type: segmentType;
    subtype: subtypeEnum;
    floorVariants?: FloorDefinition<variantEnum>[];
}

export type ColumnDefinition<columnType, subtypeEnum, segmentType, variantEnum, columnSubtype> = {
    type: columnType,
    bays?: number,
    columnSubtypes: columnSubtype[],
    inclusions: inclusionEnum[],
    uiName?: string,
    segmentDefinitions: SegmentDefinition<segmentType, variantEnum, subtypeEnum>[],
}